import React from 'react';

import { Tag } from 'antd';
import styled from 'styled-components';

import Popover from 'components/lib/Popover';
import { GROUP_ACTIVE_STATUS_LABEL, GROUP_TYPE, GROUP_TYPE_LABEL } from 'constants/groups';
import { GroupType } from 'types/groups';

const Container = styled.span`
  display: flex;
  gap: 8px;
  margin: 2px 0px 10px 0px;
`;

const Title = styled.span`
  font-family: var(--font-bold);
  font-size: 14px;
  color: var(--text-primary);
`;

const TagsContainer = styled.div`
  display: flex;
`;

interface Props {
  item: GroupType;
}

const GroupsTableGroup = ({ item }: Props) => {
  return (
    <Container>
      <Title>{item?.name}</Title>
      <TagsContainer>
        {item.company && (
          <Popover arrow={false} content={<span>{item.company.name}</span>}>
            <Tag color="green">
              {item.primary ? 'Primary' : ''} {GROUP_TYPE_LABEL[GROUP_TYPE.COMPANY]} Group
            </Tag>
          </Popover>
        )}
        {item.holding && (
          <Popover arrow={false} content={<span>{item.holding.name}</span>}>
            <Tag color="purple">
              {item.primary ? 'Primary' : ''} {GROUP_TYPE_LABEL[GROUP_TYPE.HOLDING]} Group
            </Tag>
          </Popover>
        )}
      </TagsContainer>
    </Container>
  );
};

export default GroupsTableGroup;
